import { inject } from '@angular/core';
import { CanActivateFn, GuardResult, Params, Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { APPLICATION_REDUCER } from '../../store/reducers/application.reducer';
import { map, filter, firstValueFrom, tap, Observable } from 'rxjs';
import { EViewMode } from '../configurations/application';
import { SCORECARD_REDUCER } from '../../store/reducers/scorecard.reducer';
import { ROOT_ROUTES } from '../configurations/router';
import { APPLICATION_ACTIONS } from '../../store/actions';
import { IScorecardPreview } from '../../shared/models/scorecard-preview.model';

const getRedirectionTarget = (router: Router, scoreCard: IScorecardPreview, queryParams: Params): UrlTree =>
  router.createUrlTree([`../${ROOT_ROUTES.agentPerformance}`, scoreCard.scorecardId], {
    queryParams,
  });

const getLoadedScoreCardPreview = (store: Store): Observable<IScorecardPreview[] | null> =>
  store.select(SCORECARD_REDUCER.selectScorecardPreview).pipe(
    tap({
      subscribe: () => store.dispatch(APPLICATION_ACTIONS.showLoader()),
      finalize: () => store.dispatch(APPLICATION_ACTIONS.hideLoader()),
    }),
    filter(({ loading }) => !loading),
    map(({ data }) => data),
  );

export const reviewViewModeGuard: CanActivateFn = async ({ queryParams }, { url }): Promise<GuardResult> => {
  const store = inject(Store);
  const router = inject(Router);
  const isChallengeViewMode: boolean = await firstValueFrom(
    store.select(APPLICATION_REDUCER.isViewMode(EViewMode.scoreChallengeReview)),
  );

  if (!isChallengeViewMode || url.includes(ROOT_ROUTES.agentPerformance)) {
    return true;
  }
  const scoreCardPreview = await firstValueFrom(getLoadedScoreCardPreview(store as Store));

  return scoreCardPreview?.length ? getRedirectionTarget(router, scoreCardPreview[0], queryParams) : true;
};
